import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../api/main/appStore";
import { useEffect } from "react";
import ClosedProjectsTable from "../tables/ClosedProjectsTable";

export default observer(function ClosedProjects() {
  const { commonStore, projectStore } = useStore();

  useEffect(() => {
    (async () => {
      try {
        commonStore.setLoading(true);

        await projectStore.getClosedProjects({
          isApproved: true,
          isClosed: true,
          pageNumber: 1,
          pageSize: 100,
        });
      } catch (error) {
        commonStore.handleAppError(error);
      } finally {
        commonStore.setLoading(false);
      }
    })();
  }, []);

  return (
    <Box>
      <ClosedProjectsTable data={projectStore.closedProjects} />
    </Box>
  );
});
